import React, {useEffect, useRef, useState} from 'react';

import {TouchableOpacity, View} from 'react-native';
import {Label} from "components/src/components";

import PropsType from "prop-types";

import {Color, CommonStyle, Icon, IS_WEB, ThemeUtils} from "components/src/utils";
import styles from './styles';


function RadioGroup(props) {

    const {changeOnProp, onSelectOption, disabled, contentStyle, selectedOptions, style, checkedColor, unCheckedColor, small, xsmall, large, options, size, textStyle, ml, mr, mt, mb} = props;
    const index = options.findIndex(item => item.value === selectedOptions || item.id === selectedOptions);
    const [selectedIndex, setSelectedIndex] = useState(index !== -1 ? index : -1);
    const isFirstRun = useRef(true);
    useEffect(() => {
        if (changeOnProp) {
            setSelectedIndex(options.findIndex(item => item.value === selectedOptions || item.id === selectedOptions))
        }
    }, [selectedOptions])

    useEffect(() => {
        if (!isFirstRun.current) {

            onSelectOption && options[selectedIndex] && onSelectOption(options[selectedIndex].value !== undefined ? options[selectedIndex].value : options[selectedIndex].id)
        } else {
            isFirstRun.current = false
        }
    }, [selectedIndex]);

    return (
        <View style={[contentStyle, {opacity: disabled ? 0.5 : 1}]}>
            {options.map((item, index) => (
                <TouchableOpacity activeOpacity={1}
                                  style={style}
                                  disabled={disabled}
                                  onPress={() => setSelectedIndex(index)}>
                    <View style={[styles.container]}>
                        <Icon name={index === selectedIndex ? 'radio-select' : 'radio-normal'}
                              size={size}
                              color={index === selectedIndex ? checkedColor : unCheckedColor}/>
                        <Label small={small}
                               mr={15}
                               xsmall={xsmall}
                               large={large}
                               {...props.labelProps}
                               style={[styles.rightText, textStyle, IS_WEB && !item.icon ? CommonStyle.flex : null]}>
                            {item.name}
                        </Label>
                        {item.icon}

                    </View>
                </TouchableOpacity>
            ))}
        </View>
    )
}

RadioGroup.defaultProps = {
    checkedColor: Color.SECONDARY,
    unCheckedColor: Color.PRIMARY_LIGHT,
    size: ThemeUtils.fontNormal,
    small: true,
    disabled: false

};

RadioGroup.propTypes = {
    checkedColor: PropsType.string,
    unCheckedColor: PropsType.string,
    size: PropsType.number,
    onSelectOption: PropsType.func,
    textStyle: PropsType.style,
    options: PropsType.array.isRequired,


};

export default RadioGroup
